import store from 'shared/store'

export const clearStore = () => {
  store.clearStore()
}

export default () => {
  store.initStore()
}
